import { EVENT_MAP } from "@/lib/events";
import { teamStyle } from "@/lib/colors";
import { DISC_KEYS, disciplineEntries } from "@/lib/discipline";

const TeamDiscipline = ({ match, side }) => (
  <div data-testid={`discipline-${side}`} className="border border-white/15 bg-[#131313]">
    <h3 style={teamStyle(match[side])} className="font-display text-2xl font-bold uppercase px-5 py-3 truncate">{match[side].name}</h3>
    <ul className="divide-y divide-white/10">
      {DISC_KEYS.map((k) => {
        const t = EVENT_MAP[k];
        const list = disciplineEntries(match, side, k);
        return (
          <li key={k} data-testid={`discipline-${side}-${k}`} className="px-5 py-3 flex gap-4 items-start">
            <span className="w-1.5 self-stretch shrink-0" style={{ background: t.color }} />
            <div className="flex-1 min-w-0">
              <p className="font-semibold">{t.label}</p>
              <div className="flex flex-wrap gap-2 mt-1">
                {list.length ? list.map((x) => (
                  <span key={x.id} className="text-sm px-2 py-0.5 border border-white/15 text-zinc-200">
                    {x.who} <span className="text-zinc-500">· {x.minute}</span>
                  </span>
                )) : <span className="text-sm text-zinc-600">—</span>}
              </div>
            </div>
            <span data-testid={`discipline-${side}-${k}-count`} className="font-display text-2xl font-bold tabular-nums">{list.length}</span>
          </li>
        );
      })}
    </ul>
  </div>
);

export const DisciplineByTeam = ({ match }) => (
  <div className="grid md:grid-cols-2 gap-6">
    <TeamDiscipline match={match} side="home" />
    <TeamDiscipline match={match} side="away" />
  </div>
);
